import { render, staticRenderFns } from "./MealsWeekListItem.vue?vue&type=template&id=7ebad852"
import script from "./MealsWeekListItem.vue?vue&type=script&lang=js"
export * from "./MealsWeekListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports